module.exports = __webpack_public_path__ + "img/logo-white-icon.652866a1.png";